/* eslint-disable no-case-declarations */
import { bindActionCreators } from "redux";
import { call, put, select, take, takeLatest } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import AppError from "./../../ultis/AppError";

export const GET_LIST_CALL_INTERACTIVE_LOG = "GET_LIST_CALL_INTERACTIVE_LOG";
export const GET_LIST_CALL_INTERACTIVE_LOG_ERROR =
  "GET_LIST_CALL_INTERACTIVE_LOG_ERROR";
export const GET_LIST_CALL_INTERACTIVE_LOG_SUCCESS =
  "GET_LIST_CALL_INTERACTIVE_LOG_SUCCESS";

export const COUNT_IL = "COUNT_IL";
export const COUNT_IL_SUCCESS = "COUNT_IL_SUCCESS";
export const COUNT_IL_ERROR = "COUNT_IL_ERROR";

export const MAKE_A_CALL = "MAKE_A_CALL";
export const MAKE_A_CALL_ERROR = "MAKE_A_CALL_ERROR";
export const MAKE_A_CALL_SUCCESS = "MAKE_A_CALL_SUCCESS";

export const GET_DETAIL = "GET_DETAIL";
export const GET_DETAIL_SUCCESS = "GET_DETAIL_SUCCESS";
export const GET_DETAIL_ERROR = "GET_DETAIL_ERROR";

export const GET_INFO_TELESALE = "GET_INFO_TELESALE";
export const GET_INFO_TELESALE_ERROR = "GET_INFO_TELESALE_ERROR";
export const GET_INFO_TELESALE_SUCCESS = "GET_INFO_TELESALE_SUCCESS";

export const UPDATE_INTERACTIVE_LOG = "UPDATE_INTERACTIVE_LOG";
export const UPDATE_INTERACTIVE_LOG_ERROR = "UPDATE_INTERACTIVE_LOG_ERROR";
export const UPDATE_INTERACTIVE_LOG_SUCCESS = "UPDATE_INTERACTIVE_LOG_SUCCESS";

export const CHANGE_STATE_INTERACTIVE_LOG = "CHANGE_STATE_INTERACTIVE_LOG";
export const CHANGE_STATE_INTERACTIVE_LOG_SUCCESS =
  "CHANGE_STATE_INTERACTIVE_LOG_SUCCESS";
export const CHANGE_STATE_INTERACTIVE_LOG_ERROR =
  "CHANGE_STATE_INTERACTIVE_LOG_ERROR";

export const GET_RE_CALL_LOG = "GET_RE_CALL_LOG";
export const GET_RE_CALL_LOG_ERROR = "GET_RE_CALL_LOG_ERROR";
export const GET_RE_CALL_LOG_SUCCESS = "GET_RE_CALL_LOG_SUCCESS";

export const GET_ARTICLE_LOG = "GET_ARTICLE_LOG";
export const GET_ARTICLE_ERROR = "GET_ARTICLE_ERROR";
export const GET_ARTICLE_SUCCESS = "GET_ARTICLE_SUCCESS";

export const EXPORT_INTERACTIVE_LOG = "EXPORT_INTERACTIVE_LOG";
export const EXPORT_INTERACTIVE_LOG_ERROR = "EXPORT_INTERACTIVE_LOG_ERROR";
export const EXPORT_INTERACTIVE_LOG_SUCCESS = "EXPORT_INTERACTIVE_LOG_SUCCESS";

export const EDIT_INTERACTIVE_EDIT = "EDIT_INTERACTIVE_EDIT";
export const EDIT_INTERACTIVE_EDIT_ERROR = "EDIT_INTERACTIVE_EDIT_ERROR";
export const EDIT_INTERACTIVE_EDIT_SUCCESS = "EDIT_INTERACTIVE_EDIT_SUCCESS";

export const GET_TODAY_MIX_CALL = "GET_TODAY_MIX_CALL";
export const GET_TODAY_MIX_CALL_SUCCESS = "GET_TODAY_MIX_CALL_SUCCESS";
export const GET_TODAY_MIX_CALL_ERROR = "GET_TODAY_MIX_CALL_ERROR";

export const GET_INFO_CUSTOMER = "GET_INFO_CUSTOMER";
export const GET_INFO_CUSTOMER_SUCCESS = "GET_INFO_CUSTOMER_SUCCESS";
export const GET_INFO_CUSTOMER_ERROR = "GET_INFO_CUSTOMER_ERROR";

export const GET_INFO_PHONE_NUMBER = "GET_INFO_PHONE_NUMBER";
export const GET_INFO_PHONE_NUMBER_SUCCESS = "GET_INFO_PHONE_NUMBER_SUCCESS";
export const GET_INFO_PHONE_NUMBER_ERROR = "GET_INFO_PHONE_NUMBER_ERROR";

export const GET_TICKET_BY_PHONENUMBER = "GET_TICKET_BY_PHONENUMBER";
export const GET_TICKET_BY_PHONENUMBER_SUCCESS =
  "GET_TICKET_BY_PHONENUMBER_SUCCESS";
export const GET_TICKET_BY_PHONENUMBER_ERROR =
  "GET_TICKET_BY_PHONENUMBER_ERROR";
export const UPDATE_TICKET_BY_NUMBER = "UPDATE_TICKET_BY_NUMBER";
export const UPDATE_TICKET_BY_NUMBER_SUCCESS =
  "UPDATE_TICKET_BY_NUMBER_SUCCESS";
export const UPDATE_TICKET_BY_NUMBER_ERROR = "UPDATE_TICKET_BY_NUMBER_ERROR";

export const ADD_NOTE_TO_CALL = "ADD_NOTE_TO_CALL";
export const ADD_NOTE_TO_CALL_SUCCESS = "ADD_NOTE_TO_CALL_SUCCESS";
export const ADD_NOTE_TO_CALL_ERROR = "ADD_NOTE_TO_CALL_ERROR";

export const GET_MIX_CALL = "GET_MIX_CALL";
export const GET_MIX_CALL_SUCCESS = "GET_MIX_CALL_SUCCESS";
export const GET_MIX_CALL_ERROR = "GET_MIX_CALL_ERROR";

export const TRANFER_CALL_TO_AGENT = "TRANFER_CALL_TO_AGENT";
export const TRANFER_CALL_TO_AGENT_SUCCESS = "TRANFER_CALL_TO_AGENT_SUCCESS";
export const TRANFER_CALL_TO_AGENT_ERROR = "TRANFER_CALL_TO_AGENT_ERROR";

export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER";
export const ADD_NEW_CUSTOMER_ERROR = "ADD_NEW_CUSTOMER_ERROR";
export const ADD_NEW_CUSTOMER_SUCCESS = "ADD_NEW_CUSTOMER_SUCCESS";

export const GET_AGENT_REPORT_WORKING = "GET_AGENT_REPORT_WORKING";
export const GET_AGENT_REPORT_WORKING_ERROR = "GET_AGENT_REPORT_WORKING_ERROR";
export const GET_AGENT_REPORT_WORKING_SUCCESS =
  "GET_AGENT_REPORT_WORKING_SUCCESS";

export const GET_REQUEST_BHXH = "GET_REQUEST_BHXH";
export const GET_REQUEST_BHXH_ERROR = "GET_REQUEST_BHXH_ERROR";
export const GET_REQUEST_BHXH_SUCCESS = "GET_REQUEST_BHXH_SUCCESS";

export const FIND_POS = "FIND_POS";
export const FIND_POS_SUCCESS = "FIND_POS_SUCCESS";
export const FIND_POS_OFFICE_SUCCESS = "FIND_POS_OFFICE_SUCCESS";
export const FIND_POS_ERROR = "FIND_POS_ERROR";

export const GET_REFERENCE_RESOURCE = "GET_REFERENCE_RESOURCE";
export const GET_REFERENCE_RESOURCE_ERROR = "GET_REFERENCE_RESOURCE_ERROR";
export const GET_REFERENCE_RESOURCE_SUCCESS = "GET_REFERENCE_RESOURCE_SUCCESS";

export const GET_ACCOUNT = "GET_ACCOUNT";
export const GET_ACCOUNT_SUCCESS = "GET_ACCOUNT_SUCCESS";
export const GET_ACCOUNT_ERROR = "GET_ACCOUNT_ERROR";

export const FIND_LEAD = "FIND_LEAD";
export const FIND_LEAD_SUCCESS = "FIND_LEAD_SUCCESS";
export const FIND_LEAD_ERROR = "FIND_LEAD_ERROR";

export const CLEAR = "CLEAR";

export const GET_INFO_CUSTOMER_WITHOUT_SOCKET =
  "GET_INFO_CUSTOMER_WITHOUT_SOCKET";
export const GET_INFO_CUSTOMER_WITHOUT_SOCKET_SUCCESS =
  "GET_INFO_CUSTOMER_WITHOUT_SOCKET_SUCCESS";
export const GET_INFO_CUSTOMER_WITHOUT_SOCKET_ERROR =
  "GET_INFO_CUSTOMER_WITHOUT_SOCKET_ERROR";

export const GET_INFO_SERVICES = "GET_INFO_SERVICES";
export const GET_INFO_SERVICES_SUCCESS = "GET_INFO_SERVICES_SUCCESS";
export const GET_INFO_SERVICES_ERROR = "GET_INFO_SERVICES_ERROR";

export const UPDATE_PAGE_INFORMATION = "UPDATE_PAGE_INFORMATION";

export const GET_DETAIL_INTERACTIVELOG = "GET_DETAIL_INTERACTIVELOG";
export const GET_DETAIL_INTERACTIVELOG_SUCCESS =
  "GET_DETAIL_INTERACTIVELOG_SUCCESS";
export const GET_DETAIL_INTERACTIVELOG_ERROR =
  "GET_DETAIL_INTERACTIVELOG_ERROR";

export const UPDATE_LIST_INTERACTIVELOG = "UPDATE_LIST_INTERACTIVELOG";

export const FIND_POST_OFFICE_REQUEST = "FIND_POST_OFFICE_REQUEST";
export const FIND_POST_OFFICE_SUCCESS = "FIND_POST_OFFICE_SUCCESS";
export const FIND_POST_OFFICE_ERROR = "FIND_POST_OFFICE_ERROR";

export const FIND_HANDLE_PEOPLE_REQUEST = "FIND_HANDLE_PEOPLE_REQUEST";
export const FIND_HANDLE_PEOPLE_SUCCESS = "FIND_HANDLE_PEOPLE_SUCCESS";
export const FIND_HANDLE_PEOPLE_ERROR = "FIND_HANDLE_PEOPLE_ERROR";

export const RECEIVE_PAUSE_AGENT = "RECEIVE_PAUSE_AGENT";
export const CLOSE_PAUSE_AGENT = "CLOSE_PAUSE_AGENT";

export const OPEN_DIALOG_PACKAGE_DETAIL = "OPEN_DIALOG_PACKAGE_DETAIL";
export const SET_OPEN_DIALOG_PACKAGE_DETAIL = "SET_OPEN_DIALOG_PACKAGE_DETAIL";
/**
 * Reducer
 */

const initialState = {
  calls: [],
  call: {},
  error: false,
  count: 0,
  loading: false,
  infoTelesale: {},
  excel: {},
  logInboundOutbound: [],
  loadingLog: false,
  infoCustomer: {},
  loadingInfo: false,
  getTicket: [],
  loadingTicket: false,
  note: {},
  loadCall: false,
  callInfo: [],
  tranfer: {},
  socket: {},
  contact: {},
  agentReport: [],
  contactBHXH: {},
  openDialogPackageDetail: false,
  pos: [],
  posOffice: [],
  values: [],
  articles: {},
  loadingBadge: false,
  isLoading: false,
  accountId: [],
  lead: [],
  leadLoading: false,
  infoCustomerWithoutSocket: null,
  services: [],
  isShowModal: true,
  newIdTicket: null,
  updateArrayTicket: [],
  phoneSocket: "",
  callStatus: "",
  postOfficeLoading: false,
  postOffice: [],
  handlePeople: [],
  handlePeopleLoading: false,
  pauseAgent: [],
  infoPhone: {},
  loadingInfoPhone: false,
};

export const callReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CALL_INTERACTIVE_LOG:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CALL_INTERACTIVE_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        calls: action.payload,
      };
    case GET_LIST_CALL_INTERACTIVE_LOG_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //get
    case GET_RE_CALL_LOG:
      return {
        ...state,
        loadingBadge: true,
      };
    case GET_RE_CALL_LOG_SUCCESS:
      return {
        ...state,
        loadingBadge: false,
        logs: action.payload,
      };
    case GET_RE_CALL_LOG_ERROR:
      return {
        ...state,
        error: action.error,
        loadingBadge: false,
      };
    //count list
    case COUNT_IL:
      return {
        ...state,
      };
    case COUNT_IL_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_IL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //make
    case MAKE_A_CALL:
      return {
        ...state,
      };
    case MAKE_A_CALL_SUCCESS:
      return {
        ...state,
        call: action.payload,
      };
    case MAKE_A_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //detail
    case GET_DETAIL:
      return {
        ...state,
        loading: true,
      };
    case GET_DETAIL_SUCCESS:
      return {
        ...state,
        call: action.payload,
      };
    case GET_DETAIL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //info
    case GET_INFO_TELESALE:
      return {
        ...state,
      };
    case GET_INFO_TELESALE_SUCCESS:
      return {
        ...state,
        infoTelesale: action.payload,
      };
    case GET_INFO_TELESALE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //FORM
    case UPDATE_INTERACTIVE_LOG:
      return {
        ...state,
      };
    case UPDATE_INTERACTIVE_LOG_SUCCESS:
      let calls = { ...state.calls };
      for (const key in calls) {
        if (calls[key].id === action.payload.id) {
          calls[key] = action.payload;
        }
      }

      return {
        ...state,
        calls,
      };
    case UPDATE_INTERACTIVE_LOG_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //change state
    case CHANGE_STATE_INTERACTIVE_LOG:
      return {
        ...state,
      };
    case CHANGE_STATE_INTERACTIVE_LOG_SUCCESS:
      return {
        ...state,
        state: action.payload,
      };
    case CHANGE_STATE_INTERACTIVE_LOG_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //export
    case EXPORT_INTERACTIVE_LOG:
      return {
        ...state,
        loadingExcel: true,
      };
    case EXPORT_INTERACTIVE_LOG_SUCCESS:
      return {
        ...state,
        excel: action.payload,
        loadingExcel: false,
      };
    case EXPORT_INTERACTIVE_LOG_ERROR:
      return {
        ...state,
        error: action.error,
        loadingExcel: true,
      };

    //export
    case EDIT_INTERACTIVE_EDIT:
      return {
        ...state,
      };
    case EDIT_INTERACTIVE_EDIT_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_INTERACTIVE_EDIT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //today mix call
    case GET_TODAY_MIX_CALL:
      return {
        ...state,
        loadingLog: true,
      };
    case GET_TODAY_MIX_CALL_SUCCESS:
      return {
        ...state,
        logInboundOutbound: action.payload,
        loadingLog: false,
      };
    case GET_TODAY_MIX_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loadingLog: false,
      };
    //info customer
    case GET_INFO_CUSTOMER:
      return {
        ...state,
        loadingInfo: false,
        phoneSocket: action.data.phone,
      };
    case GET_INFO_CUSTOMER_SUCCESS:
      return {
        ...state,
        infoCustomer: action.payload,
        loadingInfo: true,
      };
    case GET_INFO_CUSTOMER_ERROR:
      return {
        ...state,
        error: action.error,
        loadingInfo: false,
      };

    case GET_INFO_PHONE_NUMBER:
      return {
        ...state,
        loadingInfoPhone: true,
      };
    case GET_INFO_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        infoPhone: action.payload,
        loadingInfoPhone: false,
      };
    case GET_INFO_PHONE_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
        loadingInfoPhone: false,
      };
    //ticket
    case GET_TICKET_BY_PHONENUMBER:
      return {
        ...state,
        loadingTicket: true,
      };
    case GET_TICKET_BY_PHONENUMBER_SUCCESS:
      return {
        ...state,
        getTicket: action.payload,
        loadingTicket: false,
      };
    case GET_TICKET_BY_PHONENUMBER_ERROR:
      return {
        ...state,
        error: action.error,
        loadingTicket: false,
      };
    //update ticket
    case UPDATE_TICKET_BY_NUMBER:
      return {
        ...state,
        loadingTicket: true,
      };
    case UPDATE_TICKET_BY_NUMBER_SUCCESS:
      const getTicketClone = [...state.getTicket];
      const index = getTicketClone.findIndex(
        (element) => element.id === action.payload.id
      );

      if (index !== -1) {
        // Thay thế phần tử cũ bằng phần tử mới
        getTicketClone[index] = action.payload;
      }
      return {
        ...state,
        getTicket: getTicketClone,
        loadingTicket: false,
      };
    case UPDATE_TICKET_BY_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
        loadingTicket: false,
      };
    //note
    case ADD_NOTE_TO_CALL:
      return {
        ...state,
      };
    case ADD_NOTE_TO_CALL_SUCCESS:
      return {
        ...state,
        note: action.payload,
        logInboundOutbound: state.logInboundOutbound.map((item) => {
          if (item.id === action.payload.id) {
            item.note = action.payload.note;
          }
          return item;
        }),
      };
    case ADD_NOTE_TO_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get
    case GET_MIX_CALL:
      return {
        ...state,
        loadCall: true,
      };
    case GET_MIX_CALL_SUCCESS:
      return {
        ...state,
        callInfo: action.payload,
        loadCall: false,
      };
    case GET_MIX_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loadCall: false,
      };
    //Tranfer
    case TRANFER_CALL_TO_AGENT:
      return {
        ...state,
      };
    case TRANFER_CALL_TO_AGENT_SUCCESS:
      return {
        ...state,
        tranfer: action.payload,
      };
    case TRANFER_CALL_TO_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //add new
    case ADD_NEW_CUSTOMER:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.payload,
      };
    case ADD_NEW_CUSTOMER_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //agent report
    case GET_AGENT_REPORT_WORKING:
      return {
        ...state,
      };
    case GET_AGENT_REPORT_WORKING_SUCCESS:
      return {
        ...state,
        agentReport: action.payload,
      };
    case GET_AGENT_REPORT_WORKING_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_REQUEST_BHXH:
      return {
        ...state,
      };
    case GET_REQUEST_BHXH_SUCCESS:
      return {
        ...state,
        contactBHXH: action.payload,
      };
    case GET_REQUEST_BHXH_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case SET_OPEN_DIALOG_PACKAGE_DETAIL:
      return {
        ...state,
        openDialogPackageDetail: action.payload,
      };
    case GET_REFERENCE_RESOURCE:
      return {
        ...state,
      };
    case GET_REFERENCE_RESOURCE_SUCCESS:
      return {
        ...state,
        values: action.payload,
      };
    case GET_REFERENCE_RESOURCE_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case FIND_POS:
      return {
        ...state,
        isLoading: true,
      };
    case FIND_POS_SUCCESS:
      return {
        ...state,
        pos: action.payload,
        isLoading: false,
      };
    case FIND_POS_OFFICE_SUCCESS:
      return {
        ...state,
        posOffice: action.payload,
        isLoading: false,
      };
    case FIND_POS_ERROR:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case GET_ARTICLE_LOG:
      return {
        ...state,
        loadingBadge: true,
      };
    case GET_ARTICLE_SUCCESS:
      return {
        ...state,
        articles:
          typeof action.payload === "object"
            ? Object.keys(action.payload)
                .map((key) => action.payload[key])
                .filter((item) => item.isNew === true)
            : action.payload,
        loadingBadge: false,
      };
    case GET_ARTICLE_ERROR:
      return {
        ...state,
        articles: null,
        loadingBadge: false,
        error: action.error,
      };

    case GET_ACCOUNT:
      return {
        ...state,
      };
    case GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        accountId: action.payload,
      };
    case GET_ACCOUNT_ERROR:
      return {
        ...state,
        accountId: [],
        error: action.error,
      };
    case FIND_LEAD:
      return {
        ...state,
        leadLoading: true,
        isShowModal: true,
      };
    case FIND_LEAD_SUCCESS:
      return {
        ...state,
        lead: action.payload,
        leadLoading: false,
        isShowModal: false,
      };
    case FIND_LEAD_ERROR:
      return {
        ...state,
        lead: [],
        leadLoading: false,
        isShowModal: false,
        error: action.error,
      };
    case CLEAR:
      return {
        ...state,
        posOffice: [],
        accountId: [],
      };
    case GET_INFO_CUSTOMER_WITHOUT_SOCKET:
      return {
        ...state,
      };
    case GET_INFO_CUSTOMER_WITHOUT_SOCKET_SUCCESS:
      return {
        ...state,
        infoCustomerWithoutSocket: action.payload,
      };
    case GET_INFO_CUSTOMER_WITHOUT_SOCKET_ERROR:
      return {
        ...state,
        infoCustomerWithoutSocket: null,
        error: action.error,
      };
    case GET_INFO_SERVICES:
      return {
        ...state,
      };
    case GET_INFO_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
      };
    case GET_INFO_SERVICES_ERROR:
      return {
        ...state,
        services: [],
      };
    case UPDATE_PAGE_INFORMATION:
      const newCall =
        action.data.calls &&
        action.data.calls.length > 0 &&
        action.data.calls.map((val) => {
          return {
            ...val,
            createdAt: datetimeHelper.toFormat(
              val.createdAt,
              "YYYY-MM-DD HH:mm:ss"
            ),
            recallTime: datetimeHelper.toFormat(
              val.recallTime,
              "YYYY-MM-DD HH:mm:ss"
            ),
          };
        });

      return {
        ...state,
        count: action.data.loading ? state.count : action.data.count,
        loading: action.data.loading,
        calls: action.data.loading ? state.calls : { ...newCall },
      };
    case GET_DETAIL_INTERACTIVELOG:
      return {
        ...state,
      };
    case UPDATE_LIST_INTERACTIVELOG:
      const copyData =
        typeof state.calls === "object"
          ? Object.keys(state.calls).map((key) => state.calls[key])
          : state.calls;
      const callsArray = [...copyData];
      let idTicketNew = "";
      let updateArrayTicket = [];

      callsArray.forEach((item, index) => {
        if (
          action.payload.customFields.packageId &&
          item.id === action.payload.interactivelogId
        ) {
          let newTicket = item.ticket ? [...item.ticket] : [];
          item.formResult = action.formResult.formResult;
          if (newTicket && newTicket.length > 0) {
            if (newTicket.some((t) => t.id === action.payload.id)) {
              callsArray.ticket = newTicket.map((v) => {
                if (v.id === action.payload.id) {
                  // console.log('a');
                  return {
                    ...action.payload,
                  };
                }
                return v;
              });
              updateArrayTicket = newTicket.map((k) => {
                if (k.id === action.payload.id) {
                  return {
                    ...action.payload,
                  };
                }
                return k;
              });
            } else {
              // console.log('b');
              item.ticket = newTicket.concat([action.payload]);
              updateArrayTicket = newTicket.concat([action.payload]);
              idTicketNew = action.payload.id;
            }
          } else {
            // console.log('c');
            item.ticket = [action.payload];
            updateArrayTicket = [action.payload];
            idTicketNew = action.payload.id;
          }
        } else if (item.id === action.payload.interactivelogId) {
          // console.log('d');
          item.ticket = [action.payload];
          item.formResult = action.formResult.formResult;
          idTicketNew = action.payload.id;
        }
      });

      let newCalls = { ...callsArray };

      return {
        ...state,
        calls: newCalls,
        newIdTicket: idTicketNew,
        updateArrayTicket,
      };
    case GET_DETAIL_INTERACTIVELOG_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case FIND_POST_OFFICE_REQUEST:
      return {
        ...state,
        postOfficeLoading: true,
      };
    case FIND_POST_OFFICE_SUCCESS:
      return {
        ...state,
        postOfficeLoading: false,
        postOffice: action.payload,
      };
    case FIND_POST_OFFICE_ERROR:
      return {
        ...state,
        postOfficeLoading: false,
        postOffice: [],
      };
    case FIND_HANDLE_PEOPLE_REQUEST:
      return {
        ...state,
        handlePeopleLoading: true,
      };
    case FIND_HANDLE_PEOPLE_SUCCESS:
      return {
        ...state,
        handlePeopleLoading: false,
        handlePeople: action.payload,
      };
    case FIND_HANDLE_PEOPLE_ERROR:
      return {
        ...state,
        handlePeopleLoading: false,
        handlePeople: [],
      };
    case RECEIVE_PAUSE_AGENT: {
      const { agent } = action.data;

      const pauseAgent = [...state.pauseAgent].map((item) => {
        if (
          agent.message.userId === item.message.userId &&
          agent.open === true
        ) {
          return {
            ...item,
            open: true,
          };
        } else if (
          agent.message.userId === item.message.userId &&
          agent.open === false
        ) {
          return {
            ...item,
            open: false,
          };
        }
        return item;
      });
      const check = [...state.pauseAgent].some(
        (c) => c.message.userId === agent.message.userId
      );
      if (!check) {
        pauseAgent.unshift(agent);
      }

      return {
        ...state,
        pauseAgent,
      };
    }
    case CLOSE_PAUSE_AGENT: {
      const { agent } = action.data;
      const tempPauseAgent = [...state.pauseAgent];
      return {
        ...state,
        pauseAgent: tempPauseAgent.map((val) => {
          if (val.userId === agent.userId) {
            return {
              ...val,
              open: !val.open,
            };
          }
          return val;
        }),
      };
    }
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListCall = (order, limit, skip, where, include) => ({
  type: GET_LIST_CALL_INTERACTIVE_LOG,
  data: {
    order,
    limit,
    skip,
    where,
    include,
  },
});

export const exportInteractiveLog = (where) => ({
  type: EXPORT_INTERACTIVE_LOG,
  data: {
    where,
  },
});

export const countIl = (where) => ({
  type: COUNT_IL,
  data: {
    where,
  },
});

export const makeACall = (id) => ({
  type: MAKE_A_CALL,
  data: {
    id,
  },
});

export const getInfoTelesale = (id, include) => ({
  type: GET_INFO_TELESALE,
  data: {
    id,
    include,
  },
});

export const getDetail = (id) => ({
  type: GET_DETAIL,
  data: {
    id,
  },
});

export const updateForm = (id, formResult, contact, note, stageId) => ({
  type: UPDATE_INTERACTIVE_LOG,
  data: {
    id,
    formResult,
    contact,
    note,
    stageId,
  },
});

export const changeStateInteractiveLog = (
  id,
  stageId,
  agentId,
  recallTime
) => ({
  type: CHANGE_STATE_INTERACTIVE_LOG,
  data: {
    id,
    stageId,
    agentId,
    recallTime,
  },
});

export const getRecallLog = (agentId, to) => ({
  type: GET_RE_CALL_LOG,
  data: {
    agentId,
    to,
  },
});

export const getArticleLog = (order, limit, skip, where) => ({
  type: GET_ARTICLE_LOG,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const editInteractiveLog = (id, data) => ({
  type: EDIT_INTERACTIVE_EDIT,
  data: {
    id,
    data,
  },
});

export const getTodayMixCalls = (phone) => ({
  type: GET_TODAY_MIX_CALL,
  data: {
    phone,
  },
});

export const getInfoCustomer = (phone, serviceId, businessId) => ({
  type: GET_INFO_CUSTOMER,
  data: {
    phone,
    serviceId,
    businessId,
  },
});

export const getInfoPhoneNumber = (phone) => ({
  type: GET_INFO_PHONE_NUMBER,
  data: {
    phone,
  },
});

export const getInfoCustomerWithoutSocket = (phone, serviceId, businessId) => ({
  type: GET_INFO_CUSTOMER_WITHOUT_SOCKET,
  data: {
    phone,
    serviceId,
    businessId,
  },
});

export const getRequestBHXH = (mabuugui) => ({
  type: GET_REQUEST_BHXH,
  data: {
    mabuugui,
  },
});

export const setOpenDialogPackageDetail = (open) => ({
  type: OPEN_DIALOG_PACKAGE_DETAIL,
  data: {
    open,
  },
});

export const getTicketByNumber = (where) => ({
  type: GET_TICKET_BY_PHONENUMBER,
  data: {
    where,
  },
});
export const updateTicketByNumber = (id, value, callback) => ({
  type: UPDATE_TICKET_BY_NUMBER,
  data: {
    id,
    value,
    callback,
  },
});

export const getMixCall = (phone, all) => ({
  type: GET_MIX_CALL,
  data: {
    phone,
    all,
  },
});

export const addNoteCall = (note, callId, cdrId, type, dialMode) => ({
  type: ADD_NOTE_TO_CALL,
  data: {
    note,
    callId,
    cdrId,
    type,
    dialMode,
  },
});

export const tranferCallToAgent = (id, data) => ({
  type: TRANFER_CALL_TO_AGENT,
  data: {
    id,
    data,
  },
});

export const addNewCustomer = (address, phone, email, name) => ({
  type: ADD_NEW_CUSTOMER,
  data: {
    address,
    phone,
    email,
    name,
  },
});

export const getAgentReportWorking = () => ({
  type: GET_AGENT_REPORT_WORKING,
});

export const findPos = (code, limit) => ({
  type: FIND_POS,
  data: { code, limit },
});

export const getReferenceResource = (id) => ({
  type: GET_REFERENCE_RESOURCE,
  data: { id },
});

export const getAccount = (name) => ({
  type: GET_ACCOUNT,
  data: { name },
});

export const findLead = (code, limit) => ({
  type: FIND_LEAD,
  data: { code, limit },
});

export const clearProps = () => ({
  type: CLEAR,
});

export const getServices = () => ({
  type: GET_INFO_SERVICES,
});

export const updateNextPage = (count, loading, calls) => ({
  type: UPDATE_PAGE_INFORMATION,
  data: { count, loading, calls },
});

export const getDetailInteractiveLog = (id) => ({
  type: GET_DETAIL_INTERACTIVELOG,
  data: { id },
});

export const updateFormInteractiveLog = (payload) => ({
  type: UPDATE_INTERACTIVE_LOG_SUCCESS,
  payload,
});

export const findPostOffice = (name, limit) => ({
  type: FIND_POST_OFFICE_REQUEST,
  data: {
    name,
    limit,
  },
});

export const findHandlePeople = (name, limit) => ({
  type: FIND_HANDLE_PEOPLE_REQUEST,
  data: {
    name,
    limit,
  },
});

export const receivePauseCall = (agent) => ({
  type: RECEIVE_PAUSE_AGENT,
  data: {
    agent,
  },
});

export const closePauseCall = (agent) => ({
  type: CLOSE_PAUSE_AGENT,
  data: {
    agent,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateFormInteractiveLog,
      getListCall,
      makeACall,
      getDetail,
      getInfoTelesale,
      updateForm,
      countIl,
      changeStateInteractiveLog,
      getRecallLog,
      exportInteractiveLog,
      editInteractiveLog,
      getTodayMixCalls,
      getInfoCustomer,
      getInfoPhoneNumber,
      getTicketByNumber,
      addNoteCall,
      getMixCall,
      tranferCallToAgent,
      addNewCustomer,
      getAgentReportWorking,
      getRequestBHXH,
      findPos,
      getReferenceResource,
      getArticleLog,
      getAccount,
      findLead,
      clearProps,
      getInfoCustomerWithoutSocket,
      getServices,
      updateNextPage,
      getDetailInteractiveLog,
      findPostOffice,
      findHandlePeople,
      receivePauseCall,
      closePauseCall,
      setOpenDialogPackageDetail,
    },
    dispatch
  );
};

/**
 * Apis
 */
const addNewCustomerApi = (address, phone, email, name) => {
  return apiCaller.post("/mini-crm/vnpost-crm-gateway/save-contact", {
    address,
    phone,
    email,
    name,
  });
};
const findPosApi = (code, limit) => {
  const filter = { code, limit };
  // return apiCaller.getData(`/mini-crm/vnpost-crm-gateway/find-pos`, {filter})
  return apiCaller.getData(`/mini-crm/vnpost-crm-gateway/get-user`, { filter });
};

const findLeadApi = (code, limit) => {
  const filter = { code, limit };
  return apiCaller.getData(`/mini-crm/vnpost-crm-gateway/get-user`, { filter });
};

const findAccountApi = (name) => {
  return apiCaller.getData(`/mini-crm/vnpost-crm-gateway/get-account`, {
    name,
  });
};

const getListCallApi = (order, limit, skip, where, include) => {
  return apiCaller.getLogs("/mini-crm/interactive-log", {
    order,
    limit,
    skip,
    ...where,
    ...include,
  });
};

const countApi = (where) => {
  return apiCaller.getData("/mini-crm/interactive-log/count", { ...where });
};

const makeACallApi = (id) => {
  return apiCaller.post(`/mini-crm/call/${id}`);
};

const getInfoTelesaleApi = (id, include) => {
  return apiCaller.getLogs(`/mini-crm/call/${id}`, { ...include });
};

const changeStateInteractiveLogApi = (id, stageId, agentId, recallTime) => {
  return apiCaller.post(`/mini-crm/interactive-log/${id}/change-stage`, {
    stageId,
    agentId,
    recallTime,
  });
};

const updateFormApi = (id, formResult, contact, note, stageId) => {
  return apiCaller.putRequest(
    `/mini-crm/interactive-log/${id}`,
    { ...formResult, ...contact, note, stageId },
    { timeout: 5000 }
  );
};

const getReCallLogApi = (agentId, to) => {
  return apiCaller.getData("/mini-crm/interactive-log/get-recall-list", {
    agentId,
    to,
  });
};

const getListArticleApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/article", {
    order,
    limit,
    skip,
    ...where,
  });
};

const exportInteractiveLogApi = (where) => {
  return apiCaller.getLogs("/mini-crm/interactive-log?query=export", {
    ...where,
  });
};

const editInteractiveLogApi = (id, data) => {
  return apiCaller.put(`/mini-crm/interactive-log/${id}`, { ...data });
};

const getInteractiveLogApi = (id) => {
  return apiCaller.get(`/mini-crm/interactive-log/${id}`);
};

const getTodayMixCallsApi = (phone) => {
  return apiCaller.getData(`/cloud-pbx/get-today-mixed-calls`, { phone });
};

const getMixCallsApi = (phone, all) => {
  return apiCaller.getData(
    `/cloud-pbx/get-mixed-calls`,
    all ? { phone, customDate: "2000-01-01" } : { phone }
  );
};

const getInfoCustomerApi = (phone, serviceId, businessId) => {
  return apiCaller.getData("/mini-crm/contact/get-contact-by-phone", {
    phone,
    serviceId,
    businessId,
  });
};

const getInfoPhoneNumberApi = (phone) => {
  return apiCaller.getData("/mini-crm/contact/get-contact-by-phone", { phone });
};

const getRequestBHXHApi = (mabuugui) => {
  return apiCaller.getData(
    `/mini-crm/vnpost-crm-gateway/get-package?packageId=${mabuugui}`
  );
};

// export const getTicketByNumberApi = (where) => {
//   return apiCaller.getLogs("/mini-crm/ticket?query=log", {
//     where,
//     order: "createdAt DESC",
//   });
// };
export const getTicketByNumberApi = (where) => {
  return apiCaller.getRequest("/mini-crm-v2/api/v1/zoho/tickets", {
    ...where,
  });
};

export const updateTicketByNumberApi = (id, where) => {
  return apiCaller.patch(`/mini-crm-v2/api/v1/zoho/tickets/${id}`, {
    ...where,
  });
};

const addNoteCallApi = (note, callId, cdrId, type, dialMode) => {
  return apiCaller.post("/cloud-pbx/active-call/note", {
    note,
    callId,
    cdrId,
    type,
    dialMode,
  });
};

const tranferCallToAgentApi = (id, data) => {
  return apiCaller.post(`/cloud-pbx/active-call/${id}`, { ...data });
};

const getAgentReportWorkingApi = () => {
  return apiCaller.get(`/cloud-pbx/get-report-agent`);
};

const getReferenceResourceApi = (id) => {
  return apiCaller.getData(
    `/mini-crm/reference-resource/5e86f769c894c03e1f63f784`,
    { id }
  );
};

const getServicesApi = () => {
  return apiCaller.getData(`/mini-crm/vnpost-crm-gateway/get-product`);
};

const getPostOfficeApi = (text, limit) => {
  return apiCaller.getData("/mini-crm/reference-resource/search", {
    id: "5f17af404b750f1714530d73",
    field: "post",
    text,
    limit,
  });
};

const getHandlePeopleApi = (text, limit) => {
  return apiCaller.getData("/mini-crm/vnpost-crm-gateway/search-user", {
    text,
    limit,
  });
};

/**
 * sagas
 */

export const findPostOfficeFlow = function* () {
  while (true) {
    const action = yield take(FIND_POST_OFFICE_REQUEST);
    try {
      const res = yield call(
        getPostOfficeApi,
        action.data.name,
        action.data.limit
      );
      yield put({ type: FIND_POST_OFFICE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: FIND_POST_OFFICE_ERROR, error });
    }
  }
};

export const findHandlePeopleFlow = function* () {
  while (true) {
    const action = yield take(FIND_HANDLE_PEOPLE_REQUEST);
    try {
      const res = yield call(
        getHandlePeopleApi,
        action.data.name,
        action.data.limit
      );
      yield put({ type: FIND_HANDLE_PEOPLE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: FIND_HANDLE_PEOPLE_ERROR, error });
    }
  }
};

export const exportInteractiveLogFlow = function* () {
  while (true) {
    const action = yield take(EXPORT_INTERACTIVE_LOG);
    try {
      const res = yield call(exportInteractiveLogApi, action.data.where);
      res.data.forEach((item) => {
        item.createdAt = datetimeHelper.toFormat(
          item.createdAt,
          "YYYY-MM-DD HH:mm:ss"
        );
        item.recallTime = datetimeHelper.toFormat(
          item.recallTime,
          "YYYY-MM-DD HH:mm:ss"
        );
      });
      yield put({
        type: EXPORT_INTERACTIVE_LOG_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: EXPORT_INTERACTIVE_LOG_ERROR, error });
    }
  }
};

export const getInteractiveLogFlow = function* () {
  while (true) {
    const action = yield take(GET_DETAIL_INTERACTIVELOG);
    try {
      const res = yield call(getInteractiveLogApi, action.data.id);
      res.data.createdAt = datetimeHelper.toFormat(
        res.data.createdAt,
        "YYYY-MM-DD HH:mm:ss"
      );
      res.data.recallTime = datetimeHelper.toFormat(
        res.data.recallTime,
        "YYYY-MM-DD HH:mm:ss"
      );
      yield put({
        type: GET_DETAIL_INTERACTIVELOG_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_DETAIL_INTERACTIVELOG_ERROR, error });
    }
  }
};

export const getListCallFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CALL_INTERACTIVE_LOG);
    try {
      const res = yield call(
        getListCallApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.include
      );
      res.data.forEach((item) => {
        item.createdAt = datetimeHelper.toFormat(
          item.createdAt,
          "YYYY-MM-DD HH:mm:ss"
        );
        item.recallTime = datetimeHelper.toFormat(
          item.recallTime,
          "YYYY-MM-DD HH:mm:ss"
        );
      });
      yield put({
        type: GET_LIST_CALL_INTERACTIVE_LOG_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_CALL_INTERACTIVE_LOG_ERROR, error });
    }
  }
};

export const makeACallFlow = function* () {
  while (true) {
    const action = yield take(MAKE_A_CALL);
    try {
      const res = yield call(makeACallApi, action.data.id, action.data.include);
      yield put({ type: MAKE_A_CALL_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: MAKE_A_CALL_ERROR, error });
    }
  }
};

export const getInfoTelesaleFlow = function* () {
  while (true) {
    const action = yield take(GET_INFO_TELESALE);
    try {
      const res = yield call(getInfoTelesaleApi, action.data.id);
      yield put({ type: GET_INFO_TELESALE_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_INFO_TELESALE_ERROR, error });
    }
  }
};

export const findPosFlow = function* () {
  while (true) {
    const action = yield take(FIND_POS);
    try {
      const res = yield call(findPosApi, action.data.code, action.data.limit);
      // res.data.forEach(item =>{
      //         item.value = item.id;
      //         item.label = item.unitName;
      // })
      // switch (action.data.typeSelect) {
      //     case "Post_Office__c":
      //         yield put({ type: FIND_POS_OFFICE_SUCCESS, payload: res.data })
      //         break;
      //     case "POS_Chu_Tri__c":
      //         yield put({ type: FIND_POS_SUCCESS, payload: res.data })
      //         break;
      // }
      yield put({ type: FIND_POS_OFFICE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: FIND_POS_ERROR, error });
    }
  }
};

export const findLeadFlow = function* () {
  while (true) {
    const action = yield take(FIND_LEAD);
    try {
      const res = yield call(findLeadApi, action.data.code, action.data.limit);
      yield put({ type: FIND_LEAD_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: FIND_LEAD_ERROR, error });
    }
  }
};

export const findAccountFlow = function* () {
  while (true) {
    const action = yield take(GET_ACCOUNT);
    try {
      const res = yield call(findAccountApi, action.data.name);
      yield put({ type: GET_ACCOUNT_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_ACCOUNT_ERROR, error });
    }
  }
};

export const getDetailFow = function* () {
  while (true) {
    const action = yield take(GET_DETAIL);
    const calls = yield select((state) => state.call);
    if (calls.length) {
      const _calls = calls.filter((c) => c.id == action.data.id);
      if (_calls.length == 1) {
        const call = _calls[0];
        yield put({ type: GET_DETAIL_SUCCESS, payload: call });
        continue;
      }
    }
    try {
      const res = yield call(getListCallApi);
      yield put({
        type: GET_LIST_CALL_INTERACTIVE_LOG_SUCCESS,
        payload: { ...res.data },
      });
      const _calls = res.data.filter((c) => c.id == action.data.id);
      if (_calls.length == 1) {
        const call = _calls[0];
        yield put({ type: GET_DETAIL_SUCCESS, payload: call });
        continue;
      } else {
        throw new AppError(null, "Không tìm thấy bản ghi này");
      }
    } catch (error) {
      const history = globalHistory();
      history.replace(`${process.env.REACT_APP_PATH}/mini-crm/call`);
      yield put({ type: GET_DETAIL_ERROR, error });
    }
  }
};

const updateFormSaga = function* (action) {
  try {
    const res = yield call(
      updateFormApi,
      action.data.id,
      action.data.formResult,
      action.data.contact,
      action.data.note,
      action.data.stageId
    );
    yield put({
      type: UPDATE_INTERACTIVE_LOG_SUCCESS,
      payload: { ...res.data },
    });
  } catch (error) {
    yield put({ type: UPDATE_INTERACTIVE_LOG_ERROR, error });
  }
};

export const updateFormFlow = function* () {
  yield takeLatest(UPDATE_INTERACTIVE_LOG, updateFormSaga);
};

export const editInteractiveLogFlow = function* () {
  while (true) {
    const action = yield take(EDIT_INTERACTIVE_EDIT);
    try {
      const res = yield call(
        editInteractiveLogApi,
        action.data.id,
        action.data.data
      );
      yield put({
        type: EDIT_INTERACTIVE_EDIT_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: EDIT_INTERACTIVE_EDIT_ERROR, error });
    }
  }
};

export const countFlow = function* () {
  while (true) {
    const action = yield take(COUNT_IL);
    try {
      const res = yield call(countApi, action.data.where);
      yield put({ type: COUNT_IL_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_IL_ERROR, error });
    }
  }
};

export const changeStateInteractiveLogFlow = function* () {
  while (true) {
    const action = yield take(CHANGE_STATE_INTERACTIVE_LOG);
    try {
      const res = yield call(
        changeStateInteractiveLogApi,
        action.data.id,
        action.data.stageId,
        action.data.agentId,
        action.data.recallTime
      );
      yield put({
        type: CHANGE_STATE_INTERACTIVE_LOG_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: CHANGE_STATE_INTERACTIVE_LOG_ERROR, error });
    }
  }
};

export const getReCallLogFlow = function* () {
  while (true) {
    const action = yield take(GET_RE_CALL_LOG);
    try {
      const res = yield call(
        getReCallLogApi,
        action.data.agentId,
        action.data.to
      );
      yield put({ type: GET_RE_CALL_LOG_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_RE_CALL_LOG_ERROR, error });
    }
  }
};

export const getArticleLogFlow = function* () {
  while (true) {
    const action = yield take(GET_ARTICLE_LOG);
    try {
      const res = yield call(
        getListArticleApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_ARTICLE_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_ARTICLE_ERROR, error });
    }
  }
};

export const getTodayMixCallsFlow = function* () {
  while (true) {
    const action = yield take(GET_TODAY_MIX_CALL);
    try {
      const res = yield call(getTodayMixCallsApi, action.data.phone);
      yield put({ type: GET_TODAY_MIX_CALL_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_TODAY_MIX_CALL_ERROR, error });
    }
  }
};

export const getMixCallsFlow = function* () {
  while (true) {
    const action = yield take(GET_MIX_CALL);
    try {
      const res = yield call(
        getMixCallsApi,
        action.data.phone,
        action.data.phone
      );
      yield put({ type: GET_MIX_CALL_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_MIX_CALL_ERROR, error });
    }
  }
};

export const getAgentReportWorkingFlow = function* () {
  while (true) {
    const action = yield take(GET_AGENT_REPORT_WORKING);
    try {
      const res = yield call(getAgentReportWorkingApi);
      yield put({ type: GET_AGENT_REPORT_WORKING_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_AGENT_REPORT_WORKING_ERROR, error });
    }
  }
};

export const getInfoCustomerFlow = function* () {
  while (true) {
    const action = yield take(GET_INFO_CUSTOMER);
    try {
      const res = yield call(
        getInfoCustomerApi,
        action.data.phone,
        action.data.serviceId,
        action.data.businessId
      );
      yield put({ type: GET_INFO_CUSTOMER_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_INFO_CUSTOMER_ERROR, error });
    }
  }
};

export const getInfoPhoneNumberFlow = function* () {
  while (true) {
    const action = yield take(GET_INFO_PHONE_NUMBER);
    try {
      const res = yield call(getInfoPhoneNumberApi, action.data.phone);
      yield put({ type: GET_INFO_PHONE_NUMBER_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_INFO_PHONE_NUMBER_ERROR, error });
    }
  }
};

export const getInfoCustomerWithoutSocketFlow = function* () {
  while (true) {
    const action = yield take(GET_INFO_CUSTOMER_WITHOUT_SOCKET);
    try {
      const res = yield call(
        getInfoCustomerApi,
        action.data.phone,
        action.data.serviceId,
        action.data.businessId
      );
      yield put({
        type: GET_INFO_CUSTOMER_WITHOUT_SOCKET_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      yield put({ type: GET_INFO_CUSTOMER_WITHOUT_SOCKET_ERROR, error });
    }
  }
};

export const getTicketByNumberFlow = function* () {
  while (true) {
    const action = yield take(GET_TICKET_BY_PHONENUMBER);
    try {
      const res = yield call(getTicketByNumberApi, action.data.where);
      yield put({
        type: GET_TICKET_BY_PHONENUMBER_SUCCESS,
        payload: res?.data?.data?.data || [],
      });
    } catch (error) {
      yield put({ type: GET_TICKET_BY_PHONENUMBER_ERROR, error });
    }
  }
};

export const updateTicketByNumberFlow = function* () {
  while (true) {
    const action = yield take(UPDATE_TICKET_BY_NUMBER);
    try {
      const res = yield call(
        updateTicketByNumberApi,
        action.data.id,
        action.data.value
      );
      if (res.status === 200) {
        action.data.callback();
      }
      yield put({
        type: UPDATE_TICKET_BY_NUMBER_SUCCESS,
        payload: res?.data?.data || [],
      });
    } catch (error) {
      yield put({ type: UPDATE_TICKET_BY_NUMBER_ERROR, error });
    }
  }
};

export const addNoteCallFlow = function* () {
  while (true) {
    const action = yield take(ADD_NOTE_TO_CALL);
    try {
      const res = yield call(
        addNoteCallApi,
        action.data.note,
        action.data.callId,
        action.data.cdrId,
        action.data.type,
        action.data.dialMode
      );
      yield put({
        type: ADD_NOTE_TO_CALL_SUCCESS,
        payload: { ...res.data, id: action.data.callId },
      });
    } catch (error) {
      yield put({ type: ADD_NOTE_TO_CALL_ERROR, error });
    }
  }
};

export const tranferCallToAgentFlow = function* () {
  while (true) {
    const action = yield take(TRANFER_CALL_TO_AGENT);
    try {
      const res = yield call(
        tranferCallToAgentApi,
        action.data.id,
        action.data.data
      );
      yield put({ type: TRANFER_CALL_TO_AGENT_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: TRANFER_CALL_TO_AGENT_ERROR, error });
    }
  }
};

export const addNewCustomerFlow = function* () {
  while (true) {
    const {
      data: { address, phone, email, name },
    } = yield take(ADD_NEW_CUSTOMER);
    try {
      const res = yield call(addNewCustomerApi, address, phone, email, name);
      yield put({ type: ADD_NEW_CUSTOMER_SUCCESS, payload: { ...res.data } });
      // const history = globalHistory();
      // history.replace(`${process.env.REACT_APP_PATH}/contact-center/contact`);
    } catch (error) {
      yield put({ type: ADD_NEW_CUSTOMER_ERROR, error });
    }
  }
};

export const requestBHXHFlow = function* () {
  while (true) {
    const action = yield take(GET_REQUEST_BHXH);
    try {
      const res = yield call(getRequestBHXHApi, action.data.mabuugui);
      yield put({ type: GET_REQUEST_BHXH_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_REQUEST_BHXH_ERROR, error });
    }
  }
};

export const openDialogPackageDetailFlow = function* () {
  while (true) {
    const action = yield take(OPEN_DIALOG_PACKAGE_DETAIL);
    yield put({
      type: SET_OPEN_DIALOG_PACKAGE_DETAIL,
      payload: action.data.open,
    });
  }
};

export const getServicesFlow = function* () {
  while (true) {
    yield take(GET_INFO_SERVICES);
    try {
      const res = yield call(getServicesApi);
      yield put({ type: GET_INFO_SERVICES_SUCCESS, payload: res.data.results });
    } catch (error) {
      yield put({ type: GET_INFO_SERVICES_ERROR, error });
    }
  }
};

export const getReferenceResourceFlow = function* () {
  while (true) {
    const action = yield take(GET_REFERENCE_RESOURCE);
    try {
      const res = yield call(getReferenceResourceApi, action.data.id);
      let province = [];
      for (const key in res.data.values) {
        if (res.data.values.hasOwnProperty(key)) {
          const data = res.data.values[key];
          if (data) {
            if (data.parentId == "") {
              province.push(data);
            }
          }
        }
      }
      yield put({ type: GET_REFERENCE_RESOURCE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_REFERENCE_RESOURCE_ERROR, error });
    }
  }
};
